import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import WhatsAppButton from "@/components/WhatsAppButton";
import CallButton from "@/components/CallButton";
import { waMessages } from "@/lib/whatsapp";

const links = [
  { to: "/cars", label: "Cars" },
  { to: "/taxi-rental-manchester", label: "Taxi Rental" },
  { to: "/private-hire-car-rental-manchester", label: "Private Hire" },
  { to: "/hybrid-taxi-rental-manchester", label: "Hybrid" },
  { to: "/guides", label: "Guides" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { stats } = useSite();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white/80 backdrop-blur-xl">
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-heading text-xl font-black tracking-tighter text-ink">
            EAZY<span className="text-[#00E676]">CAR</span>TRACK
          </span>
          <span className="mt-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">
            PHV Private Hire Rental
          </span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-semibold transition-colors hover:text-black ${
                  isActive ? "text-black" : "text-zinc-500"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span
            data-testid="nav-available-count"
            className="inline-flex items-center gap-2 rounded-full border border-border px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-zinc-700"
          >
            <span className="live-dot" /> {stats.available_count} Available
          </span>
          <CallButton size="sm" variant="dark" context="nav" testid="nav-call">Call</CallButton>
          <WhatsAppButton size="sm" message={waMessages.general()} context="nav" testid="nav-whatsapp">
            WhatsApp
          </WhatsAppButton>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-white lg:hidden">
          <div className="container-x flex flex-col gap-1 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-base font-semibold text-zinc-700 hover:bg-surface"
              >
                {l.label}
              </NavLink>
            ))}
            <div className="mt-2 flex flex-col gap-2">
              <CallButton className="w-full" variant="dark" context="mobile-menu">Call Us</CallButton>
              <WhatsAppButton className="w-full" message={waMessages.general()} context="mobile-menu">
                WhatsApp Us
              </WhatsAppButton>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
